import { useMutation, useQuery } from "@apollo/client";
import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  FormControl,
  FormGroup,
  FormLabel,
  Placeholder,
  Row,
} from "react-bootstrap";
import { toast } from "react-toastify";

import Chip from "../../../components/chip";
import Flex from "../../../components/common/Flex";
import QUERY from "../../../utils/service/query";

const ManageReasons: React.FC = () => {
  const [reason, setReason] = useState("");

  const { data, loading, error } = useQuery(QUERY.REPORTS.GET_REASONS, {
    variables: { page: 1 },
  });
  const [createReason] = useMutation(QUERY.REPORTS.CREATE_REASON);

  const checkRaeson = () => {
    if (reason.length > 2) {
      if (reason.toLowerCase() === "other") {
        toast.error("Other is a reserved reason. Can't create it again.");
        return false;
      }

      if (reason.toLowerCase() === "others") {
        toast.error("Others is a reserved reason. Can't create it again.");
        return false;
      }

      const resReasons = data?.reasonsList?.list?.map((item: any) =>
        item.title.toLowerCase(),
      );
      if (resReasons?.indexOf(reason.toLowerCase().trim()) !== -1) {
        toast.error(reason + " is already existing.");
        return false;
      }

      return true;
    } else {
      return false;
    }
  };
  return (
    <>
      <Card>
        <Card.Header>
          <h5>Manage Reasons</h5>
        </Card.Header>
        <Card.Body className="bg-light">
          <Form>
            <FormGroup as={Row}>
              <FormLabel>Add Reason</FormLabel>
              <Col sm="6">
                <FormControl
                  placeholder="Add Reason"
                  className="form-control-md"
                  value={reason}
                  onKeyDown={(e) => {
                    e.key === "Enter" &&
                      checkRaeson() &&
                      createReason({
                        variables: { title: reason },
                        refetchQueries: [
                          {
                            query: QUERY.REPORTS.GET_REASONS,
                            variables: { page: 1 },
                          },
                        ],
                      })
                        .then(() => {
                          setReason("");
                          toast.success("Reason Added Successfully");
                        })
                        .catch(() => {
                          toast.error("Something went wrong!");
                        });
                    e.key == "Enter" && e.preventDefault();
                  }}
                  onChange={(e) => setReason(e.target.value)}></FormControl>
              </Col>
              <Col sm="6">
                <Button
                  variant="primary"
                  className="form-control-md"
                  disabled={!(reason.length > 2 ? true : false)}
                  onClick={(e) => {
                    checkRaeson() &&
                      createReason({
                        variables: { title: reason },
                        refetchQueries: [
                          {
                            query: QUERY.REPORTS.GET_REASONS,
                            variables: { page: 1 },
                          },
                        ],
                      })
                        .then(() => {
                          e.preventDefault();
                          setReason("");
                          toast.success("Reason Added Successfully");
                        })
                        .catch(() => {
                          e.preventDefault();
                          toast.error("Something went wrong!");
                        });
                  }}>
                  Add
                </Button>
              </Col>
            </FormGroup>
          </Form>
          <Flex wrap={"wrap"}>
            {loading && (
              <Placeholder
                as="div"
                animation="glow"
                className="d-flex align-items-center justify-content-center  mt-2 ">
                {[...Array(3)].map((a, i) => (
                  <Placeholder
                    xs={12}
                    style={{
                      width: "150px",
                      height: "32.4px",
                      minWidth: "150px",
                      border: "1px solid var(--falcon-primary)",
                      borderRadius: "0.2rem",
                      color: "var(--falcon-primary)",
                      backgroundColor: "#edf2f9",
                      position: "relative",
                      marginRight: "8px",
                    }}
                  />
                ))}
              </Placeholder>
            )}
            {data?.reasonsList?.list &&
              data?.reasonsList?.list.map((item: any) => (
                <Chip item={item} key={item.id} />
              ))}
            {data?.reasonsList?.list?.length == 0 && <p>No Reasons Found</p>}
            {error && <p>Something went wrong!</p>}
          </Flex>
        </Card.Body>
      </Card>
    </>
  );
};

export default ManageReasons;
